// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { type EtfFilters } from '@shared/data-access/interfaces/api/ai/etf';

export const ETF_SCREENER_EXCLUDED_DEFAULT_LOCATION = 'United States';

export const etfsScreenerInitialFilters: EtfFilters = {
  asset_class: [],
  asset_manager: [],
  aum: '',
  currency: ['EUR'],
  investment_segment: [],
  location: [],
  max_aum: '',
  max_expenses_ratio: '',
  min_aum: '',
  min_expenses_ratio: '',
  ter: '',
  text_search: '',
};

const sameStringList = (a?: string[], b?: string[]) => {
  const left = a ?? [];
  const right = b ?? [];
  return (
    left.length === right.length &&
    left.every((value, index) => value === right[index])
  );
};

const sameScalar = (
  a: string | number | undefined,
  b: string | number | undefined,
) => a === b;

export const isEtfsScreenerInitialState = (filters: EtfFilters): boolean => {
  const initial = etfsScreenerInitialFilters;
  return (
    sameStringList(filters.asset_class, initial.asset_class) &&
    sameStringList(filters.asset_manager, initial.asset_manager) &&
    sameStringList(filters.currency, initial.currency) &&
    sameStringList(filters.investment_segment, initial.investment_segment) &&
    sameStringList(filters.location, initial.location) &&
    sameScalar(filters.aum, initial.aum) &&
    sameScalar(filters.ter, initial.ter) &&
    sameScalar(filters.text_search, initial.text_search) &&
    sameScalar(filters.min_aum, initial.min_aum) &&
    sameScalar(filters.max_aum, initial.max_aum) &&
    sameScalar(filters.min_expenses_ratio, initial.min_expenses_ratio) &&
    sameScalar(filters.max_expenses_ratio, initial.max_expenses_ratio)
  );
};

export const etfLocationsExcludingDefault = (locations: string[]): string[] =>
  locations.filter(loc => loc !== ETF_SCREENER_EXCLUDED_DEFAULT_LOCATION);
